import React from 'react'

import Panel from '@cinch/oxd-components/panel/src'
import { Primary } from '@cinch/oxd-components/button/src'
import Link, { Appearance } from '@cinch/oxd-components/link/src'

import styles from './valuation-actions.module.css'

interface Props {
  i18n: Cinch.WebAppTranslations['sellVehicle']['valuation']['valuationActions']
  onClickSell: () => void
}

const ValuationActions: React.FC<Props> = ({ i18n, onClickSell }) => {
  return (
    <Panel title={i18n.title} titleClass={styles.panelTitle} className={styles.panel} hasBorder={false}>
      <div className={styles.ctaContainer}>
        <Primary
          onClick={onClickSell}
          oxdClassName={styles.sellCta}
          tag={{
            event: 'click',
            eventCategory: 'link',
            eventLabel: i18n.sellCtaLabel,
            eventAction: 'view',
          }}
          oxford={true}
        >
          {i18n.sellCtaLabel}
        </Primary>
        <Link
          oxford={true}
          appearance={Appearance.outlineButton}
          to={'/find-vehicle'}
          className={styles.findCta}
          tag={{
            event: 'click',
            eventCategory: 'link',
            eventLabel: i18n.findCtaLabel,
            eventAction: 'click',
          }}
        >
          {i18n.findCtaLabel}
        </Link>
      </div>
    </Panel>
  )
}

export default ValuationActions
